module.exports = __webpack_public_path__ + "img/nl.e53fc83f.svg";